import React from 'react'
import PropTypes from 'prop-types'
import { css } from 'aphrodite'

import { Text } from './Text'
import { Image } from './Image'
import * as assets from '../assets'
import createStyles from './styles'

export class PoweredBy extends React.PureComponent {
  render() {
    const styles = getStyles(this.props, this.context)

    return (
      <div className={css(styles.root)}>
        <div className={css(styles.text)}>
          <Text color="accent">Powered by</Text>
        </div>

        <div className={css(styles.image)}>
          <Image source={assets.fullLogo} width="120" />
        </div>
      </div>
    )
  }
}

PoweredBy.contextTypes = {
  theme: PropTypes.object,
}

PoweredBy.propsTypes = {}

const getStyles = createStyles(() => ({
  root: {
    alignItems: 'center',
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'center',
    marginBottom: 30,
    marginTop: 30,
  },

  text: {},

  image: {},
}))



// WEBPACK FOOTER //
// ./src/components/PoweredBy.js